/**
 * @generated SignedSource<<8fb47c631ad3d4e82bbb6af1cb2603de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsSignInWallArticle$data = {
  readonly paywallTypes: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersIsSignInWallArticle";
};
export type helpersIsSignInWallArticle$key = {
  readonly " $data"?: helpersIsSignInWallArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsSignInWallArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsSignInWallArticle"
};

(node as any).hash = "1e7d709acfa9d7d6518073f88679558e";

export default node;
